<template>
  <div id="app">
    <header>
      <Header
        @animationstart.native="onAnimationStart"
        :class="{ [animationName]: $route.name === 'home' }"
        :fixedToTop="$route.path === '/'"
        ref="header"
        :theme-color="themeColor"
        @changeSite="handleChangeSite"
      ></Header>
    </header>
    <main>
      <transition appear :name="pageTransitionName">
        <router-view :key="routerKey" :siteConfig="siteConfig" :isCN="isCN"></router-view>
      </transition>
    </main>
    <footer v-if="$route.name !== 'products'">
      <Footer :siteConfig="siteConfig" :isCN="isCN"></Footer>
    </footer>
    <left-tools class="leftTools" :siteConfig="siteConfig" :isCN="isCN" />
    <right-tools class="rightTools" :siteConfig="siteConfig" :isCN="isCN" />
  </div>
</template>
<script>
import axios from "axios";
import leftTools from "@/components/leftTools";
import RightTools from "@/components/rightTools";
import Cookies from "js-cookie";
import { getTempToken } from "@/api/login";
export default {
  name: "App",
  components: { leftTools, RightTools },
  data() {
    return {
      intervalId: null,
      screenWidth: document.body.clientWidth,
      isCN: true,
      homeScrollY: 0,
      pageTransitionName: "",
      animationName: "",
      siteConfig: {},
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },

  computed: {
    themeColor() {
      return this.$route.path !== "/"
        ? "main-color"
        : this.homeScrollY < Math.max(400, window.innerHeight)
        ? "is-transparent"
        : "main-color";
    },
    routerKey() {
      return this.$route.path + Math.random();
    }
  },
  created() {
    // 判断是否禁用Cookie
    this.cookieEnable = true;
    const dt = new Date();
    dt.setSeconds(dt.getSeconds() + 60);
    document.cookie = "cookie-test=1; expires=" + dt.toGMTString();
    const cookiesEnabled = document.cookie.indexOf("cookie-test=") !== -1;
    if(!cookiesEnabled) {
      this.cookieEnable = false;
      this.$message({
        message: this.$t("main.PleaseEnableBrowserCookies"),
        type: 'error'
      })
    }

    this.userLanguage();
    this.$root.$on("home-scrolling", (direction, pos) => {
      this.homeScrollY = pos.y;

      if (direction.directionY === -1) {
        this.animationName = "slideInDown";
      } else {
        this.animationName = "slideOutUp";
      }
    });

    this.checkToken(false);
    // 设置一个轮询任务来定期检查token是否过期
    this.intervalId = setInterval(this.checkToken, 20000);
  },
  destroyed() {
    // 清除轮询任务
    clearInterval(this.intervalId);
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
    this.$refs.header.$el.addEventListener("animationend", function(e) {
      if (e.animationName === "slideOutUp") {
        e.target.style.top = "-100%";
      }
    });
  },
  watch: {
    screenWidth: {
      handler(newVal, oldVal) {
        if (newVal < 1250) {
          if (window.location.href.includes('/mobile/')) return;
          window.location.href = window.location.href.replace(window.location.host, window.location.host + '/mobile');
        }
        if (newVal >= 1250) {
          if (!window.location.href.includes('/mobile/')) return;
          window.location.href = window.location.href.replace(window.location.host + '/mobile', window.location.host);
        }
      },
      immediate: true,
      deep: true
    },
    $route(newRoute) {
      this.pageTransitionName = ["products", "home"].includes(newRoute.name)
        ? ""
        : "jumpPage";
    },
    "$store.state.tabs": function(newV, oldV) {
      this.siteChange(newV, oldV);
    },
    "$store.state.siteInfo": function(newV, oldV) {
      if (newV) {
        this.isCN = this.$i18n.locale === "zn";
        // 动态改变 rem 跟大小
        const htmlEl = document.documentElement;
        htmlEl.style.fontSize = this.isCN ? "14px" : "14px";

        if (typeof oldV != 'object') {
          this.siteChange(newV, oldV);
        }
      }
    }
  },
  methods: {
    checkToken(checkAppVersion = true) {
      let uuid = localStorage.getItem("WuhanWebUUID");
      let token = Cookies.get("WuhanToken");
      const differenceTime = Cookies.get("Difference");
      if (!uuid || uuid === "undefined" || uuid === "null" || !token || !differenceTime) {
        this.getUuid();
      }
      if (checkAppVersion === true) {
        this.checkAppVersion();
      }
    },
    checkAppVersion() {
      if (typeof this.$route.query.version === 'undefined') {
        axios.defaults.headers['Cache-Control'] = 'no-cache';
        axios.get('/version.json').then(res => {
          // 新老版本不一致提示用户强制刷新
          let oldVersion = localStorage.getItem("app_version");
          let newVersion = res.data.version;
          if (oldVersion !== newVersion) {
            clearInterval(this.intervalId);
            this.$alert(this.$t('main.YouMightNeedToRefreshTheCurrentWebPage'), this.$t('main.tip'), {
              confirmButtonText: this.$t('main.sure'),
              type: 'warning'
            }).then(() => {
              localStorage.setItem("app_version", newVersion);
              this.intervalId = setInterval(this.checkToken, 5000);
              Cookies.remove("hasNavTabs_1");
              Cookies.remove("hasNavTabs_2");
              Cookies.remove("hasProductType_1");
              Cookies.remove("hasProductType_2");
              location.reload(true);
            });
          }
        });
      }
    },
    getUuid() {
        getTempToken({})
            .then((res) => {
              if (res) {
                const timestamp = Date.now();
                const servertimestamp = res.data.timestamp * 1000;
                const chazhi = servertimestamp - timestamp;
                Cookies.set("Difference",chazhi);
                if (localStorage.getItem("WuhanWebUUID") == res.data.uuid) {
                } else {
                  localStorage.setItem("WuhanWebUUID",res.data.uuid);
                }
                Cookies.set("WuhanToken", res.data.token, 15);
                Cookies.set("WHTimestamp", Date.parse(new Date()) / 1000 - res.data.timestamp);
              }
            });

    },
    onAnimationStart(e) {
      if (e.animationName === "slideInDown") {
        e.target.style.top = 0;
      }
    },
    handleChangeSite(val) {
      this.siteConfig = val;
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    siteChange(newV, oldV) {
      let topNav = localStorage.getItem("navTabs_" + oldV) && JSON.parse(localStorage.getItem("navTabs_" + oldV))
      let nav = localStorage.getItem("navTabs_" + oldV) && this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + oldV)))
      let newTopNav = localStorage.getItem("navTabs_" + oldV) && JSON.parse(localStorage.getItem("navTabs_" + newV))
      let newNav = localStorage.getItem("navTabs_" + oldV) && this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + newV)))
      // 有页面标识才需要处理
      if (this.$route.params.identification && topNav && nav && newTopNav && newNav) {
        // 获取当前栏目信息
        let nowNav = nav.find(item => {
          if (item.identification) {
            return this.$route.params.identification == item.identification;
          } else {
            return this.$route.params.identification == item.id;
          }
        });
        // 获取切换站点后的栏目信息
        let toNav = newNav.find(item => {
          if (item.identification) {
            // 有标识切换到本页
            return this.$route.params.identification == item.identification;
          }
        });
        if (nowNav && !toNav) {
          // 无标识切换到顶级栏目
          let index = 0;
          if (nowNav.pid == '0') {
            index = topNav.findIndex(item => {
              return item.id == nowNav.id
            });
          } else if(nowNav) {
            index = topNav.findIndex(item => {
              return item.id == nowNav.pid
            });
          }
          toNav = newTopNav[index];
        }
        if (toNav) {
          //产品详情页面处理
          if (this.$route.path.includes('/product/detail')) {
            this.$router.push({
              path: this.getRoutesPath('detail_product', toNav['identification'], toNav['id'])
            });
          } else {
            this.$router.push({
              path: this.getRoutesPath(toNav['list_template'], toNav['identification'], toNav['id'])
            });
          }
        }
      }
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    // 判断是否中文
    userLanguage() {
      this.isCN = this.$i18n.locale === 'zn';

      // 动态改变 rem 跟大小
      const htmlEl = document.documentElement;
      htmlEl.style.fontSize = this.isCN ? "14px" : "14px";
    },
  }
};
</script>
<style lang="less">
@import url("common/font.css");
@keyframes slideInDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slideOutUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100%);
  }
}
.slideInDown {
  animation: slideInDown 0.4s;
}
.slideOutUp {
  animation: slideOutUp 0.4s;
}

.jumpPage-leave-active {
  display: none;
}
.jumpPage-enter {
  transform: translate3d(0, 80px, 0);
  opacity: 0;
}

.jumpPage-enter-active {
  transition: all 0.3s;
}
html, body, #app {
  // 通用样式
  font-family: Alibaba PuHuiTi,serif;
  font-weight: 400;
  min-width: 1200px;
}
div,
ul,
li,
dl,
dd,
dt,
h1,
h2,
h3,
h4,
h5,
h6,
header,
main,
section,
aside,
input,
button,
textarea,
.el-button,
.el-popover,
.el-select-dropdown__item,
.el-input,
.el-checkbox,
.el-form-item__label,
.el-form-item__content,
.el-checkbox__label,
.el-textarea,
.el-dialog__body,
.el-descriptions,
.el-table {
  font-family: inherit;
  font-size: inherit;
}
.el-dialog__header,
.el-dialog__title,
.el-descriptions__title{
  font-size: 1.1428rem;
}

footer {
  // margin-top: 100px;
}

table {
  border-collapse: collapse;
}

header {
  position: relative;
  z-index: 1000;
}
.leftTools {
  position: fixed;
  left: 30px;
  bottom: 15%;
  z-index: 100000;
}
.rightTools {
  position: fixed;
  right: 20px;
  top: 30%;
  z-index: 100000;
}
.message {
  max-width: 900px !important;
  min-width: 31rem !important;
}
.message.error {
  background-color: rgba(230, 14, 0,.7) !important;
  color: #fff !important;
  border: 1px salmon !important;
}
.message.success {
  background-color: rgba(99,87,150,.7) !important;
  color: #fff !important;
  border: 1px salmon !important;
}
.message__icon--error,
.message__icon--success {
  color: #fff !important;
}
.el-message-box {
  font-size: 1rem;
}
.el-message-box__title {
  font-size: 1.285rem;
}
.el-message-box__content {
  font-size: 1rem;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #635796;
  background: #635796;
}
.el-radio__input.is-checked+.el-radio__label {
  color: #635796;
}
.el-message-box .el-message-box__btns .el-button:focus,
.el-message-box .el-message-box__btns .el-button:hover,
.el-message-box .el-message-box__btns .el-button:active {
  color: #F56C6C;
  background-color: #FFF;
  border-color: #F56C6C;
}
.el-dialog__footer .el-button--danger:focus,
.el-dialog__footer .el-button--danger:hover,
.el-dialog__footer .el-button--danger:active {
  background-color: #635796;
  border-color: #635796;
  color: #FFF;
}

.el-message-box .el-message-box__btns .el-button--default,
.el-message-box .el-message-box__btns .el-button--default:focus,
.el-message-box .el-message-box__btns .el-button--default:hover,
.el-message-box .el-message-box__btns .el-button--default:active {
  background-color: #FFF;
  border-color: #635796;
  color: #635796;
}

.el-message-box .el-message-box__btns .el-button--primary,
.el-message-box .el-message-box__btns .el-button--primary:focus,
.el-message-box .el-message-box__btns .el-button--primary:hover,
.el-message-box .el-message-box__btns .el-button--primary:active {
  background-color: #635796;
  border-color: #635796;
  color: #FFF;
}

.el-message-box__status.el-icon-warning {
  color: #B8B0D4;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #635796;
  border-color: #635796;
}
.el-checkbox__inner:hover,
.el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #635796;
}
.el-select-dropdown__item.selected {
  color: #635796;
}

.el-input__inner {
  height: 32px;
  line-height: 32px;
}
.el-checkbox__inner {
  width: 1rem;
  height: 1rem;
}
.el-checkbox__inner::after {
  height: 0.5rem;
}
.el-checkbox__label {
  color: #999999;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-input__inner:focus,
.el-input.is-focus .el-input__inner,
.el-textarea__inner:focus,
.el-textarea__inner.is-focus .el-input__inner{
  border-color: #635796 !important;
}
.el-input-number {
  height: 32px;
  line-height: 32px;
}
.el-input-number.is-controls-right .el-input-number__decrease,
.el-input-number.is-controls-right .el-input-number__increase {
  line-height: 16px;
}
.el-input-number__decrease:hover,
.el-input-number__increase:hover {
  color: #635796;
}
.el-input-number__decrease,
.el-input-number__decrease:hover,
.el-input-number__increase:hover{
  color:#635796
}
.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled){
  border-color:#635796
}
.el-checkbox__input.is-checked+.el-checkbox__label {
  color:#635796
}
</style>
